<div class="vincent_subscribe" style="margin: 100px 0px;">
    <div class="vincent_container">
        <h1>{{"be_in_touch" | translate}} </h1>
        <div class="row align-center">
            <div class="col col-6">
                <a class="vincent_button vincent_button_background" routerLink="/contact"
                    style="text-align: right;"> {{"Contact" | translate}}<i class="fa fa-angle-right" aria-hidden="true"></i>
                </a>
            </div>
        </div>
    </div>
</div>